module.exports = __webpack_public_path__ + "img/ic-fb-login.08dd363a.svg";